<template>
  <div v-if="intervenant">
    <div class="card-content">
      <section class="has-text-centered">
        <p class="modal-title has-text-centered has-text-link" v-if="!isPaiement">
          {{ $t('ajoutDevis.modeSettlement') }}
        </p>
        <p class="modal-title has-text-centered has-text-link" v-else>
          {{ $t('ajoutEditContrat.bailleur.modePaiement') }}
        </p>
        <br>
      </section>
      <p class="has-text-link">
        <span class="is-italic" v-if="!isPaiement">{{ $t('ajoutDevis.modeSettlement') }} :</span>
        <span class="is-italic" v-else>{{ $t('ajoutEditContrat.bailleur.modePaiement') }} :</span>
        <span class="has-text-weight-semibold" v-if="intervenant.modeReglement">
          {{intervenant.modeReglement.libelle}}
        </span>
      </p>
      <br>
      <p class="has-text-link" v-if="afficherDelai">
        <span class="is-italic">{{ $t('ajoutDevis.periodSettlement') }} :</span>
        <span class="has-text-weight-semibold" v-if="intervenant.delaiReglement">
          {{intervenant.delaiReglement.libelle}}
        </span>
      </p>
        <div v-if="intervenant.delaiReglement && intervenant.delaiReglement.estPersonnalisable">
          <span class="is-italic" v-if="intervenant.delaiReglementDetail.nombreJourDecalage">
            {{$t('editionClient.informations.dayNumber')}} :
          </span>
          <span class="has-text-weight-semibold">
            {{intervenant.delaiReglementDetail.nombreJourDecalage}}
          </span>
          <span class="has-text-weight-semibold" v-if="intervenant.delaiReglementDetail.finDeMois">
            - {{$t('editionClient.informations.endMonth')}}
          </span>
          <br>
          <span class="is-italic" v-if="intervenant.delaiReglementDetail.finDeMois">
                {{$t('editionClient.informations.dayMonth')}} :</span>
          <span class="has-text-weight-semibold">
           {{intervenant.delaiReglementDetail.jourFinDeMois}}
          </span>
        </div>
      <br>
      <div class="has-text-centered">
        <button class="button btn-modal-annuler is-cancel has-text-centered button-modal"
                @click="modifier()">
          {{ $t('ajoutDevis.actions.edit') }}
        </button>
        <button class="button is-addOrEdit has-text-centered button-modal"
                @click="close()">
          {{ $t('ajoutDevis.actions.end') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import DELAI_JOUR_MOIS from '@/configuration/parametrage/delaiReglementConf';

export default {
  name: 'consulter-reglement',
  props: {
    intervenant: {
      type: Object,
      required: true,
    },
    afficherDelai: {
      type: Boolean,
      required: false,
      default: true,
    },
    isPaiement: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      joursDuMois: DELAI_JOUR_MOIS,
    };
  },
  computed: {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    modifier() {
      this.$emit('modifier');
    },
  },
};
</script>

<style scoped>

</style>
